export const SKILLS = [
    {
        skillName: 'HTML',
        level: 100
    },
    {
        skillName: 'SCSS/CSS',
        level: 100
    },
    {
        skillName: 'Wordpress',
        level: 80
    },
    {
        skillName: 'JavaScript',
        level: 60
    },
    {
        skillName: 'React',
        level: 40
    },
    {
        skillName: 'Bootstrap',
        level: 50
    },
    {
        skillName: 'Git',
        level: 80
    },
    {
        skillName: 'Figma',
        level: 80
    },
    {
        skillName: 'Photoshop',
        level: 80
    },
    {
        skillName: 'InDesign',
        level: 80
    },
    {
        skillName: 'Illustrator',
        level: 80
    }

  ];
  
